// extracted by mini-css-extract-plugin
export default {"WixStudioAgencyDetails__skipButton":"Y_yr45","wixStudioAgencyDetailsSkipButton":"Y_yr45"};